<div
  [attr.data-at-installation-id]="subscription.installationId"
  class="subscription-container flex flex-col justify-between items-center"
>
  <div class="full-width flex flex-row gap-[8px]">
    <div class="device-img">
      <ng-container *ngIf="deviceImage; else hideImage">
        <img src="{{ deviceImage }}" />
      </ng-container>
      <ng-template #hideImage>
        <mat-icon class="hide-image">hide_image</mat-icon>
      </ng-template>
    </div>
    <div class="details-container flex flex-col gap-[8px]">
      <div class="flex flex-row justify-between items-stretch">
        <div class="flex flex-col">
          <ng-container *ngIf="subscription?.registeredInstallation; else unregisteredDevice">
            <a
              data-at-installation-name
              [routerLink]="['/installations/', subscription.installationId]"
              [queryParams]="{ gatewaySerial: subscription?.gatewaySerial }"
              gtm="onGoToPage"
              gtmAction="Installation details"
              gtmCategory="bookingOverview"
            >
              <h4 class="installation-link">
                <ng-container *ngIf="subscription?.marketingName; else defaultMarketingName">
                  {{ subscription.marketingName }}
                </ng-container>
                <ng-template #defaultMarketingName>
                  {{ '+INSTALLATIONS.INSTALLATIONS.INSTALLATION_OF' | translate }}
                  {{ subscription.ownerName }}
                </ng-template>
              </h4>
            </a>
          </ng-container>
          <ng-template #unregisteredDevice>
            <h4>{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.UNREGISTERED_DEVICE.TITLE' | translate }}</h4>
          </ng-template>
          <p data-at-boiler-id>{{ subscription.boilerId }}</p>
        </div>
        <app-booking-package-badge
          [attr.data-at-subscription-type]="
            subscription?.trial ? subscriptionsPlanType.Trial : subscription?.plan
          "
          *ngIf="!isExpired"
          [packageType]="subscription?.plan"
          [isTrial]="subscription?.trial"
          size="small"
        ></app-booking-package-badge>
      </div>
      <p data-at-owner-name>{{ subscription.ownerName }}</p>
      <p data-at-location>
        {{ subscription.installationLocation }}
      </p>
      <ng-container *ngIf="subscription?.originalBundleInvoice">
        <p>
          <span class="info-icon"
            >{{
              '+BOOKING.OVERVIEW.SUBSCRIPTION.ACTIVATION_DATE'
                | translate: { date: subscription.subscriptionDate | date }
            }}
            <mat-icon
              matTooltip="{{
                '+BOOKING.OVERVIEW.SUBSCRIPTION.ACTIVATION_DATE_TOOLTIP' | translate
              }}"
              >info_outline</mat-icon
            >
          </span>
        </p>
        <p *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.active">
          <span>
            {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.FREE_PRO_PACKAGE' | translate }}:
            {{ getLeftDays(subscription.expirationDate) }}
          </span>
        </p>
      </ng-container>
      <p>
        <span
          data-at-automatic-extension
          *ngIf="
            subscription.plan === subscriptionsPlanType.Pro &&
              subscription.trial === false &&
              subscription.status?.toLowerCase() === subscriptionsStatusType.active;
            else expirationDate
          "
        >
          {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.AUTOMATIC_EXTENSION' | translate }}:
        </span>
        <ng-template #expirationDate>
          <span data-at-expiration-date>
            {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.EXPIRATION_DATE' | translate }}:
          </span>
        </ng-template>
        <span [attr.data-at-end-date]="subscription.expirationDate | date">
          {{ subscription.expirationDate | date }}
        </span>
      </p>
      <p
        data-at-subscription-duration
        *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.canceled"
      >
        {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.DURATION' | translate }}:
        {{ getLeftDays(subscription.expirationDate) }}
      </p>
      <p data-at-booked-by *ngIf="subscription.subscribedByName || subscription.subscribedBy">
        {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.BOOKING_FROM' | translate }}:
        {{
          subscription.subscribedByName ? subscription.subscribedByName : subscription.subscribedBy
        }}
      </p>
      <ng-container *ngIf="subscription.hardwareBundle?.orderNumber">
        <p data-at-order-number>
          {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.ORDER_NUMBER' | translate }}:
          <a
            *ngIf="subscription.hardwareBundle?.partnerShopUrl; else orderNumber"
            href="{{ subscription.hardwareBundle?.partnerShopUrl }}"
            target="_blank"
          >
            <ng-container *ngTemplateOutlet="orderNumber"></ng-container>
          </a>
          <ng-template #orderNumber>{{ subscription.hardwareBundle?.orderNumber }}</ng-template>
        </p>
      </ng-container>
      <ng-container *ngIf="subscription.hardwareBundle?.invoiceId">
        <p data-at-invoice-id>
          {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.INVOICE_ID' | translate }}:
          <span>{{ subscription.hardwareBundle?.invoiceId }}</span>
        </p>
      </ng-container>
    </div>
  </div>
  <div class="details__footer">
    <app-banner size="thin" *ngIf="shouldShowRegistrationBanner()">
      {{
        '+BOOKING.OVERVIEW.SUBSCRIPTION.UNREGISTERED_DEVICE.BANNER.DESCRIPTION'
          | translate: { plan: subscription.plan }
      }}
    </app-banner>
    <div class="btn-container full-width flex flex-row justify-center items-center">
      <ng-container *ngIf="authStore.canManageSubscriptions$ | async">
        <ng-container *ngIf="isExpired; else activeSubscriptionButtons">
          <ng-container *ngTemplateOutlet="buyPackageButton"></ng-container>
        </ng-container>
      </ng-container>
      <ng-template #activeSubscriptionButtons>
        <button
          data-at-unsubscribe-button
          [attr.data-at-disabled]="
            subscription.status?.toLowerCase() === subscriptionsStatusType.canceled ||
            subscription.trial ||
            !subscription.boilerId
          "
          *ngIf="isProPackage; else buyProButton"
          mat-stroked-button
          [disabled]="
            subscription.status?.toLowerCase() === subscriptionsStatusType.canceled ||
            subscription.trial ||
            !subscription.boilerId
          "
          gtm="onOpen"
          gtmAction="Unsubscribe package confirmation modal"
          gtmCategory="bookingOverview"
          appCancelBooking
          [boilerId]="subscription?.boilerId"
          [subscriptionPlan]="subscription?.plan"
        >
          {{
            subscription.status?.toLowerCase() === subscriptionsStatusType.canceled
              ? ('+BOOKING.OVERVIEW.BUTTON.UNSUBSCRIBED' | translate)
              : ('+BOOKING.OVERVIEW.BUTTON.UNSUBSCRIBE' | translate)
          }}
        </button>
      </ng-template>
      <ng-template #buyProButton>
        <div
          class="tooltip-wrapper"
          [matTooltip]="
            !subscription.registeredInstallation
              ? ('+BOOKING.DEVICES.TOOLTIP.UNREGISTERED_DEVICE' | translate)
              : null
          "
        >
          <button
            data-at-upgrade-to-pro-button
            mat-raised-button
            color="primary"
            [disabled]="!subscription.registeredInstallation || !subscription.boilerId"
            gtm="onSet"
            gtmAction="Pro plan"
            gtmCategory="bookingOverview"
            (click)="onProceedSubscription(subscription?.boilerId)"
          >
            {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.UPGRADE_TO_PRO' | translate }}
          </button>
        </div>
      </ng-template>
      <ng-template #buyPackageButton>
        <div
          class="tooltip-wrapper"
          [matTooltip]="
            gatewayPlatformType === platform.None
              ? ('+BOOKING.DEVICES.TOOLTIP.OFFLINE_INSTALLATION' | translate)
              : !subscription.registeredInstallation
              ? ('+BOOKING.DEVICES.TOOLTIP.UNREGISTERED_DEVICE' | translate)
              : null
          "
        >
          <button
            data-at-buy-package-button
            mat-raised-button
            color="primary"
            gtm="onSet"
            gtmAction="Buy package"
            gtmCategory="bookingOverview"
            [disabled]="
              gatewayPlatformType === platform.None ||
              isAnyActiveOrCancelledFlatRateSubscription ||
              !subscription.registeredInstallation ||
              !subscription.boilerId
            "
            [routerLink]="['/booking']"
            [queryParams]="{ boilerSerial: subscription?.boilerId, platform: gatewayPlatformType }"
          >
            {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.BUY_PACKAGE' | translate }}
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
